import { Checkbox, FormControlLabel } from '@presov.sk/presov-ui-react';
import React from 'react';
import { Field } from 'react-final-form';

type Props = {
  name: string;
  label?: string;
};

const FormCheckboxField: React.FC<Props> = ({ name, label }) => {
  return (
    <Field name={name} type='checkbox'>
      {({ input: { value, onChange, ...input } }) => (
        <FormControlLabel
          control={
            <Checkbox checked={!!value} onChange={onChange} {...input} />
          }
          label={label}
          sx={{ gap: 0.5 }}
        />
      )}
    </Field>
  );
};

export default FormCheckboxField;
